import React from "react";
import { Input, DatePicker, TimePicker, Select, Radio, Checkbox, Upload, Slider, Switch, Button } from "antd";
import { UploadOutlined } from '@ant-design/icons';

const FormGenerator = ({ field }) => {
    if (!field) return null;
    switch (field.DataType.toLowerCase()) {
        case "text":
            return <Input data-key={field.Index} value={field.Value} placeholder={`Enter ${field.Name}`} />;
        case "number":
            return <Input type="number" placeholder={`Enter ${field.Name}`} />;
        case "date":
            return <DatePicker style={{ width: '100%' }} />;
        case "select":
            return (
                <Select style={{ width: '100%' }} placeholder={`Select ${field.Name}`}>
                    {field.Options?.map(option => (
                        <Select.Option key={option.value} value={option.value}>{option.label}</Select.Option>
                    ))}
                </Select>
            );
        case "checkbox":
            return <Checkbox>{field.CheckboxLabel || field.Name}</Checkbox>;
        case "radio":
            return (
                <Radio.Group>
                    {field.Options?.map(option => (
                        <Radio key={option.value} value={option.value}>{option.label}</Radio>
                    ))}
                </Radio.Group>
            );
        case "textarea":
            return <Input.TextArea value={field.Value} rows={4} placeholder={`Enter ${field.Name}`} />;
        case "switch":
            return <Switch />;
        case "slider":
            return <Slider />;
        case "timepicker":
            return <TimePicker style={{ width: '100%' }} />;
        case "upload":
            return (
                <Upload>
                    <Button icon={<UploadOutlined />}>Click to Upload</Button>
                </Upload>
            );
        default:
            return <Input placeholder={`Enter ${field.Name}`} />;
    }
};

export { FormGenerator };
